import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CustomChannelTitle = styled(Typography)(({ theme }) => ({
  whiteSpace: 'nowrap',
  maxWidth: 1,
  cursor: 'pointer',
  '&:hover': {
    textDecoration: 'underline',
  },
}));

export const ConnectionLoadingContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  justifyContent: 'space-between',
  width: '100%',
}));
